import { render } from "./UserReauthDialog.vue?vue&type=template&id=460b00e0"
import script from "./UserReauthDialog.vue?vue&type=script&lang=js"
export * from "./UserReauthDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__